export default "__VITE_ASSET__e739e3b3__"